<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户ID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.id" placeholder="请输入用户ID"></el-input>
					</el-form-item>
					<el-form-item label="用户账号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入账号"></el-input>
					</el-form-item>
					<el-form-item label="手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入手机号"></el-input>
					</el-form-item>
					<el-form-item label="邮箱" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.email" placeholder="请输入邮箱"></el-input>
					</el-form-item>
					<el-form-item label="邀请码" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.invitationCode" placeholder="请输入邀请码">
						</el-input>
					</el-form-item>
					<el-form-item label="是否可用:" >
						<el-select v-model="searchInfo.isEnable" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="禁用" :value="0">禁用</el-option>
							<el-option key="1" label="启用" :value="1">启用</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="社区首领:" >
						<el-select v-model="searchInfo.isSubscribe" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="否" :value="0">否</el-option>
							<el-option key="1" label="是" :value="1">是</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="排序方式" class='tiny' cleartable>
						<!-- placeholder="创建时间降序" -->
						<el-select v-model="searchInfo.orderType" >
							<el-option label="上次活跃时间时间升序" :value="0"></el-option>
							<el-option label="创建时间降序" :value="1"></el-option>
							<el-option label="创建时间升序" :value="2"></el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="创建时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
								start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<!-- <el-button type="primary" @click="sendemail">发送邮件</el-button> -->
							<el-button @click="empty">清空</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>


		<el-table :data="userList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="tableLoading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="账号">
							<span>{{ props.row.username }}</span>
						</el-form-item>
						<el-form-item label="账号">
							<span v-if="props.row.isStore==true">是商家</span>
							<span v-else>不是商家</span>
						</el-form-item>
						<el-form-item label="全返消费">
							<span v-if="props.row.isMyActivate == true">已激活</span>
							<span v-else>未激活</span>
						</el-form-item>

						<el-form-item label="本人消费">
							<span>{{ props.row.shopMiningSelf?props.row.shopMiningSelf:'0' }}</span>
						</el-form-item>
						<el-form-item label="团队消费">
							<span>{{ props.row.shopMiningTeam?props.row.shopMiningTeam:'0' }}</span>
						</el-form-item>
						<el-form-item label="流量池">
							<span>{{ props.row.flowValid?props.row.flowValid:'0' }}
								(储备积分:{{ props.row.flowLock?props.row.flowLock:'0' }})</span>
						</el-form-item>


						<el-form-item label="团队总人数">
							<span>{{ props.row.teamCount?props.row.teamCount:'0' }}</span>
						</el-form-item>
						<el-form-item label="邀请码">
							<span>{{ props.row.invitationCode }}</span>
						</el-form-item>
						<el-form-item label="邀请人">
							<span v-if="props.row.inviteUsername">{{ props.row.inviterUserId }}~{{ props.row.inviteUsername}}</span>
							<span v-else>暂无</span>
						</el-form-item>
						<el-form-item label="邀请人数">
							<span>{{ props.row.inviterCount?props.row.inviterCount:'0' }}</span>
						</el-form-item>
						<el-form-item label="消息推送id">
							<span v-if="props.row.clientid && props.row.clientid!='null'">{{ props.row.clientid}}</span>
							<span v-else>无</span>
						</el-form-item>
						<el-form-item label="上次登录日期">
							<span>{{formartDate(props.row.lastActivityDate)?formartDate(props.row.lastActivityDate):'无'}}</span>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column prop="id" label="用户ID" sortable align="center" width="90">
			</el-table-column>
			<el-table-column prop="username" label="账号" align="center" :show-overflow-tooltip="true" :formatter="changeNull">
			</el-table-column>
			<el-table-column label="头像" prop="logo" align="center">
				<template slot-scope="scope">
					<img v-if="scope.row.logo" :src="scope.row.logo" style="width: 50px;height: 50px;" />
					<div v-else>暂无</div>
				</template>
			</el-table-column>
			<el-table-column prop="phone" label="手机号" align="center" :show-overflow-tooltip="true" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="email" label="邮箱" align="center" :show-overflow-tooltip="true" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="nickname" label="昵称" align="center" :show-overflow-tooltip="true" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="realname" label="真实姓名" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column prop="invitationCode" label="邀请码" align="center" width="100" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column label="注册来源" prop="isConsume" align="center" width="100">
				<template slot-scope="scope">
					<p v-if="scope.row.fromChannel=='friendInvite'">好友分享</p>
					<p v-if="scope.row.fromChannel=='scanPay'">店铺码付款自动注册</p>
					<p v-if="scope.row.fromChannel=='sytPa'">收银台付款自动注册</p>
					<p v-if="scope.row.fromChannel=='hkInvite'">客户回馈自动注册</p>
				</template>
			</el-table-column>
			<el-table-column label="消费会员" prop="isConsume" align="center" width="100">
				<template slot-scope="scope">
					<p v-if="scope.row.isConsume==0">否</p>
					<p v-if="scope.row.isConsume==1">是</p>
				</template>
			</el-table-column>
			<el-table-column prop="agentLevel" label="区域代理" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.agentLevel==0">无</p>
					<p v-if="scope.row.agentLevel==1">省代</p>
					<p v-if="scope.row.agentLevel==2">市代</p>
					<p v-if="scope.row.agentLevel==3">区代</p>
				</template>
			</el-table-column>
			<el-table-column prop="createDate" label="注册时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="isEnable" label="状态" align="center" width="60">
				<template slot-scope="scope">
					<p v-if="!scope.row.isEnable">禁用</p>
					<p v-else>启用</p>
				</template>
			</el-table-column>
			<el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="dialogVisibleFun(scope.row)">充值</el-button>
					
					<el-dropdown trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="editialogVisible(scope.row.id)">重置密码</el-dropdown-item>
							<el-dropdown-item @click.native="showEditUserDialogVisible(scope.row.id)">编辑</el-dropdown-item>
							<el-dropdown-item @click.native="toShowProperty(scope.row.id)">查看资产</el-dropdown-item>
							<el-dropdown-item @click.native="showEditAgentDialogVisible(scope.row)">设置代理</el-dropdown-item>
							<el-dropdown-item @click.native="toShowInvite(scope.row.id)">邀请关系</el-dropdown-item>
							<el-dropdown-item @click.native="wangti(scope.row.id)">网体归属</el-dropdown-item>
							<el-dropdown-item @click.native="toDelete(scope.row.id)">删除</el-dropdown-item>
							<el-dropdown-item  @click.native="toyj(scope.row)">发送邮件</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					　　　　
				</template>
			</el-table-column>
		</el-table>
		<!-- :current-page="userList.pageNum" -->
		<el-pagination style="margin: 20px 0px 20px 0px ;" background :current-page="1"
			@current-change="pageChange" :page-sizes="[10, 20, 50, 100, 150, 200,300,400,500]"
			layout="total, sizes, prev, pager, next, jumper" :total="userList.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 重置密码 -->
		<el-dialog style="float:rigin" title="编辑" :visible.sync="editDialogVisible" width="35%" :close-on-click-modal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">

					<el-form-item :label-width="formLabelWidth" label="登录密码:">
						<el-col :span="18">
							<el-input v-model="form.password" placeholder="请输入登录密码（6-16位字母+数字）" />
						</el-col>
					</el-form-item>
					<el-form-item :label-width="formLabelWidth" label="确认登录密码:">
						<el-col :span="18">
							<el-input v-model="form.surePass" placeholder="请输入确认登录密码" />
						</el-col>
					</el-form-item>

					<div style="text-align: center;">
						<el-button :loading="resetPassLoading" type="primary" @click="resetPass()">提交</el-button>
						<el-button @click="cannelPass">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</div>
				</el-form>
			</div>
		</el-dialog>

		<!-- 编辑用户信息 -->
		<el-dialog style="float:rigin" title="编辑" :visible.sync="editUserDialogVisible" :close-on-click-modal="false"
			width="50%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label-width="formLabelWidth"  label="用户账号:">
							<el-input v-model="userForm.username" :disabled="true" />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth"  label="昵称:">
							<el-input type="text" v-model="userForm.nickname" placeholder="请输入用户昵称" />
						</el-form-item>
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label-width="formLabelWidth"  label="手机号:">
							<el-input v-model="userForm.phone" />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth"  label="是否启用:">
							<el-select v-model="userForm.isEnable" placeholder="请选择">
								<el-option :key="false" label="禁用" :value="false">禁用</el-option>
								<el-option :key="true" label="启用" :value="true">启用</el-option>
							</el-select>
						</el-form-item>

					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label-width="formLabelWidth"  label="消费会员:">
							<el-select v-model="userForm.isConsume" placeholder="请选择">
								<el-option :key="0" label="否" :value="0">否</el-option>
								<el-option :key="1" label="是" :value="1">是</el-option>
							</el-select>
						</el-form-item>

						<el-form-item :label-width="formLabelWidth"  label="社区首领:">
							<el-select v-model="userForm.isSubscribe" placeholder="请选择" clear>
								<el-option :key="false" label="否" :value="false">否</el-option>
								<el-option :key="true" label="是" :value="true">是</el-option>
							</el-select>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label-width="formLabelWidth"  label="Logo">
							<!-- 图片上传 -->
							<el-upload class="avatar-uploader" :http-request="upLoadLogo" action="string"
								:before-upload="beforeAvatarUpload" multiple :show-file-list="false">
								<img style="width: 100px;height: 100px;" v-if="logo" :src="logo" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</div>


				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="editUser" :loading="editUserLoading">确 定</el-button>
				<el-button @click="editUserDialogVisible = false">取 消</el-button>
			</div>
		</el-dialog>


		<!-- 充值 -->
		<el-dialog style="float:rigin" title="充值" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
			
			<!-- <div class="app-container" style="text-align: center;">
				<el-form label-width="100px" size="medium">
					<el-form-item label="资产类型:">
						<el-select style="width: 200px;" v-model="integralId" class="big" placeholder="请选择" clear>
							<el-option v-for="item in integralList" :key="item.id" :value="item.id" :label="item.name"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>

			<div class="app-container" style="text-align: center;">
				<el-form label-width="100px" size="medium">
					<el-form-item label="数量:">
						<el-col :span="15">
							<el-input type="number" v-model="appropriation" placeholder="请输入数量" />
						</el-col>
					</el-form-item>
				</el-form>
			</div> -->
			<div class="app-container" style="text-align: center;">
				<el-form label-width="100px" size="medium">
					<el-form-item label="充值账号:">
							<span>{{ payUserName}}</span>
					</el-form-item>
					<el-form-item label="充值类型:">
						<el-col :span="8">
							<el-select v-model="rechargeType" class="big" placeholder="请选择" clear>
								<el-option  :value="1" label="充值"></el-option>
								<el-option  :value="2" label="冲正"></el-option>
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="资产:">
						<el-col :span="8">
							<!-- <el-select v-model="integralId" class="big" placeholder="请选择" clear>
								<el-option v-for="item in integralList" :key="item.id" :value="item.id"
									:label="item.name">
								</el-option>
							</el-select> -->
							<el-select style="width: 200px;" v-model="integralId" class="big" placeholder="请选择" clear>
								<el-option v-for="item in integralList" :key="item.id" :value="item.id"
								 :label="item.name"></el-option>
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item :label="rechargeType==1?'充值数量:':'冲正数量'">
						<el-col :span="10">
							<el-input type="text"  @input="validateInput" v-model="appropriation" placeholder="请输入充值数量" />
						</el-col>
					</el-form-item>
					<el-form-item>
						<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
							:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" :limit="5"
							:on-success="onSuccess1">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="备注:">
						<el-col :span="10">
							<el-input type="text" v-model="remark" placeholder="请输入备注" />
						</el-col>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="sure" :loading="sureLoading">确 定</el-button>
				<el-button @click="dialogVisible = false">取 消</el-button>
			</div>
		</el-dialog>


		<!-- 邀请下级 -->
		<el-dialog style="float:rigin" title="邀请下级" :visible.sync="inviteDialogVisible" width="80%" :close-on-click-modal="false">
			<el-table :data="inviteData.list" stripe style="width: 100%;" :header-cell-style="headClass" height="400"
				v-loading="inviteDataLoading" element-loading-text="拼命加载中"  
				element-loading-spinner="el-icon-loading" row-key="id"  lazy :load="dialogTableLoad"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column prop="id" label="UID" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="username" label="账号" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="nickname" label="昵称" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="" label="商家" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<p v-if="scope.row.isStore==true">
							<span v-if="scope.row.storeType==0">线上</span>
							<span v-if="scope.row.storeType==1">门店</span>
						</p>
						<p v-else>未开通</p>
					</template>
				</el-table-column>
				<el-table-column prop="agentLevel" label="服务商" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<p v-if="scope.row.agentLevel==0">否</p>
						<p v-if="scope.row.agentLevel==1">省级</p>
						<p v-if="scope.row.agentLevel==2">市级</p>
						<p v-if="scope.row.agentLevel==3">区县</p>
					</template>
				</el-table-column>
				<el-table-column prop="total" label="DWQ余额" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="inviterCount" label="邀请人数" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="teamCount" label="团队人数" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="shopMiningSelf" label="本人消费" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="shopMiningTeam" label="团队消费"  align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="teamCount" label="流量池"  align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{ scope.row.flowValid?scope.row.flowValid:'0' }}
						(储备积分:{{ scope.row.flowLock?scope.row.flowLock:'0' }})</span>
					</template>
					
				</el-table-column>
				<el-table-column prop="lastActivityDate" label="登录" align="center" :show-overflow-tooltip="true">
				</el-table-column>
			</el-table>
			<el-pagination style="margin: 20px;" background :current-page="inviteData.pageNum"
				@current-change="pageInviteChange" :page-sizes="[10, 20, 50, 100, 150, 200]" layout="total, sizes, prev, pager,next"
				:total="inviteData.total" @size-change="handleInviteSizeChange">
			</el-pagination>
			<div style="text-align: center;">
				<el-button @click="inviteDialogVisible = false">返回</el-button>
			</div>
		</el-dialog>

		<!-- 设置代理 -->
		<el-dialog style="float:rigin" title="设置代理" :visible.sync="editAgentDialogVisible" :close-on-click-modal="false"
			width="50%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<el-form-item label="代理类型:" label-width="150px">
						<el-select v-model="setTLevelData.agentLevel" placeholder="请选择" @change="chooseLevel">
							<!-- <el-option key="0" label="无" :value="0">无</el-option> -->
							<el-option key="1" label="省代" :value="1">省代</el-option>
							<el-option key="2" label="市代" :value="2">市代</el-option>
							<el-option key="3" label="区代" :value="3">区代</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="省:" label-width="150px"
						v-if="setTLevelData.agentLevel==1 || setTLevelData.agentLevel==2 || setTLevelData.agentLevel==3">
						<el-select clearable filterable v-model="provinceId" placeholder="请选择省" @change="provinceFocus">
							<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="市:" label-width="150px" v-if="setTLevelData.agentLevel==2 || setTLevelData.agentLevel==3">
						<el-select clearable filterable v-model="cityId" placeholder="请选择市" @change="cityFcus">
							<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="区:" label-width="150px" v-if="setTLevelData.agentLevel==3">
						<el-select clearable filterable v-model="areaId" placeholder="请选择区" @change="districtFcus">
							<el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editAgentDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="editAgent()" :loading="editAgentLoading">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 查看资产 -->
		<el-dialog style="float: rigin" title="用户资产" :visible.sync="propertyDialogVisible" width="60%" append-to-body
		:close-on-click-modal="false">
			<el-table :data="userPropertyList.list" stripe style="width: 100%;" :header-cell-style="headClass"
				v-loading="loadingUserProperty" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
				>
				<el-table-column prop="username" label="用户账号" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="nickname" label="用户昵称" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="phone" label="手机号" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="introduce" label="资产名称" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="inUseCnt" label="可用" align="center">
					<template slot-scope="scope">
						<span> {{scope.row.inUseCnt}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="lockCnt" label="冻结" align="center">
					<template slot-scope="scope">
						<span> {{scope.row.lockCnt}}</span>
					</template>
				</el-table-column>
				
			</el-table>
		</el-dialog>

		<!-- 网体归属 -->
		<el-dialog style="float:rigin" title="网体归属" :visible.sync="wtDialogVisible" width="80%"
		:close-on-click-modal="false">
			<el-table :data="twData.list" stripe style="width: 100%;" :header-cell-style="headClass"
				v-loading="loadingTwo" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" 
				height="550"
				row-key="id"
				:tree-props="{ hasChildren: 'hasChildren', children: 'children' }">

			<!-- <el-table :data="twData.list" stripe style="width: 100%;" :header-cell-style="headClass" height="400"
				v-loading="loadingTwo" element-loading-text="拼命加载中" 
				element-loading-spinner="el-icon-loading" row-key="id"  lazy :load="load"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}"> -->
				<el-table-column prop="id" label="UID" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="username" label="账号" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="nickname" label="昵称" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="" label="商家" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<p v-if="scope.row.isStore==true">
							<span v-if="scope.row.storeType==0">线上</span>
							<span v-if="scope.row.storeType==1">门店</span>
						</p>
						<p v-else>未开通</p>
					</template>
				</el-table-column>
				<el-table-column prop="agentLevel" label="服务商" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<p v-if="scope.row.agentLevel==0">否</p>
						<p v-if="scope.row.agentLevel==1">省级</p>
						<p v-if="scope.row.agentLevel==2">市级</p>
						<p v-if="scope.row.agentLevel==3">区县</p>
					</template>
				</el-table-column>
				<el-table-column prop="total" label="DWQ余额" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="inviterCount" label="邀请人数" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="teamCount" label="团队人数" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="shopMiningSelf" label="本人消费" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="shopMiningTeam" label="团队消费"  align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="teamCount" label="流量池"  align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{ scope.row.flowValid?scope.row.flowValid:'0' }}
						(储备积分:{{ scope.row.flowLock?scope.row.flowLock:'0' }})</span>
					</template>
					
				</el-table-column>
				<el-table-column prop="lastActivityDate" label="登录" align="center" :show-overflow-tooltip="true">
				</el-table-column>
			</el-table>
		
			<el-pagination background :current-page="twData.pageNum"
				@current-change="pageWgChange" layout="total, sizes, prev, pager,next" :total="twData.total"
				@size-change="handleWgSizeChange">
			</el-pagination>
			<span slot="footer" class="dialog-footer">
				<el-button @click="wtDialogVisible = false">返回</el-button>
			</span>
		</el-dialog>
		<!-- 发送邮件 -->
		<el-dialog style="float:rigin" center title="发送邮件" :visible.sync="emailvisible" :close-on-click-modal="false"
			width="50%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="text-align: start;margin: 10px 0;font-size: 16rpx;font-weight: 700;">邮箱地址：
						<div style="height: 10px;"></div>
						<el-input type="textarea" v-model="emailInfo.email"  placeholder="请输入接收人邮箱地址，多个请使用;分隔" />
					</div>
					<div style="text-align: start;margin: 10px 0;font-size: 16rpx;font-weight: 700;">邮件标题：
					<div style="height: 10px;"></div>
						<el-input type="text" v-model="emailInfo.emailTitle" placeholder="请输入邮件标题" />
					</div>
					<div style="margin-top: 10px;">
						<div style="text-align: start;margin: 10px 0;font-size: 16rpx;font-weight: 700;display: flex;justify-content: space-between;">
						邮件内容:
						<div style="display: flex;justify-content: space-between;">
							<!-- <div style="margin-right: 10px;color: #1d99f7;">
								常用模板1
								常用模板2
								常用模板3
							</div> -->
							<div @click="mb">
								更多模板>
							</div>
						</div>
						</div>
						<el-form-item>
							<div id="lpc-quill" class="quill" style="width: 100%; height:520px">
								<el-upload class="upload-demo1" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload1" :on-success="upScuccess1" :on-error="uploadError" />
								<quill-editor v-model="emailInfo.emailContent" ref="myQuillEditor1" 
								class="editer1" :options="editorOption1" style="height:500px"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="emailvisible = false">取 消</el-button>
				<el-button type="primary" @click="send()" >确 定</el-button>
			</div>
		</el-dialog>
		<!-- 模板 -->
		<el-dialog style="float:rigin" center :title="isadd?'新增模板':'编辑模板'" :visible.sync="addmbvisible" :close-on-click-modal="false"
			width="50%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="text-align: start;margin: 10px 0;font-size: 16rpx;font-weight: 700;">模板标题：
						<div style="height: 10px;"></div>
						<el-input type="text" v-model="mbinfo.emailTitle" placeholder="请输入模板标题" />
					</div>
					<div style="text-align: start;margin: 10px 0;font-size: 16rpx;font-weight: 700;">邮件标题：
					<div style="height: 10px;"></div>
						<el-input type="text" v-model="mbinfo.emailSubtitle" placeholder="请输入邮件标题" />
					</div>
					<div>
						<div style="text-align: start;margin: 10px 0;font-size: 16rpx;font-weight: 700;display: flex;justify-content: space-between;">
						邮件内容:
					
						</div>
						<el-form-item>
							<div id="lpc-quill" class="quill" style="width: 100%; height:520px">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess" :on-error="uploadError" />
								<quill-editor v-model="mbinfo.emailContent" ref="myQuillEditor" 
								class="editer" :options="editorOption" style="height:500px"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addmbvisible = false">取 消</el-button>
				<el-button type="primary" @click="editmb()" v-if="!isadd">确 定</el-button>
				<el-button type="primary" @click="setaddmb()" v-else>确 定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog style="float:rigin" center title="邮件模板列表" :visible.sync="mbvisible" :show-close="false" :close-on-click-modal="false"
			width="50%" >
			<div slot="title" class="dialog-footer" style="position: relative;">
				   邮件模板列表
				
			
			  </div>
			 <div style="position: absolute;top: 20px;right: 30px;font-size: 16px;color: black;" @click="addmb">增加模板</div>
			<div class="app-container" style="text-align: center;">
				 <el-radio-group v-model="radios" style="display: flex;flex-wrap: wrap;gap: 20px 0;">
				    <el-radio :label="item.id" v-for="item in mblist">{{item.emailTitle}}
					<i @click="addmb(item)" class="el-icon-edit-outline"></i>
					</el-radio>
				   
				  </el-radio-group>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="mbvisible = false">取 消</el-button>
				<el-button type="primary" @click="mbset()" >确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('user');
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				mblist:[],
				radios:0,
				httpUrl: urls,
				tableLoading: false, //表格
				resetPassLoading: false, //重置密码
				sureLoading:false, //充值
				inviteDataLoading: false, //邀请关系表格
				editUserLoading: false, // 编辑
				userList: [{}], //用户列表
				inviteDialogVisible: false,
				details:"",
				dialogVisible: false,
				editDialogVisible: false,
				editUserDialogVisible: false, // 编辑用户弹窗
				integralId: "", //积分id
				integralList: [],
				appropriation: "",
				isadd:false,
				ids: '', //授权用户id
				userData: [{}], //用户角色列表
				userDataList: [], //用户角色列表选中的
				formLabelWidth: "100px",
				form: {
					username: "",
					password: "",
					surePass: ""
				},
				mainFormRules: {
					username: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
					password: {
						required: true,
						message: "请输入密码",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10,
					invitePageNum: 1,
					invitePageSize: 10,

					WGPageNum: 1,
					WGPageSize: 10,
				},
				searchInfo: {
					isEnable: '',
					isSubscribe: '',
					orderType: 1
				},
				inviteData: [],
				setTLevelData: {
					agentLevel: "",
					provinceId: "",
					cityId: "",
					areaId: "",
					status: false,
					userId: "",
					id: "",
					data: [{
							name: ""
						},
						{
							name: ""
						},
						{
							name: ""
						}
					]
				},
				provinceId: '',
				cityId: '',
				areaId: '',
				provinceList: {}, //省
				cityList: {}, //市
				districtList: {}, //区
				userForm: {},
				logo: "",
				payUserName:'', //充值用户
				rechargeType:1, //充值类型
				fileList: [], //充值图片
				goodsImages: [],
				cidImages:[],
				remark:'', //充值备注
				emailvisible:false,
				editAgentDialogVisible: false, // 设置代理弹窗
				editAgentLoading: false, //设置代理
				userId: '',
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							
							handlers: {
								image: function (value) {
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				},
				editorOption1: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							
							handlers: {
								image: function (value) {
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo1 input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				},
				userPropertyList: [],
				propertyDialogVisible: false,
				loadingUserProperty: false,

				//网体归属
				wtDialogVisible: false,
				twData: {},
				mbinfo:{},
				wgid:'',
				emailInfo:{},
				loadingTwo: false,
				mbvisible:false,
				addmbvisible:false,
				mbId:''
			};
		},

		methods: {
			mbset(){
				this.mbId=this.radios
				this.mbvisible=false
				this.$api.findbyIdListemail(this.mbId).then(res=>{
					console.log(res);
					this.emailInfo=res.data
				})
			},
			setaddmb(){
				this.$api.addmail({...this.mbinfo}).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.$api.findListemail().then(res=>{
							console.log(res.data.list);
							this.mblist=res.data.list
						})
						setTimeout(()=>{
							this.addmbvisible = false;
						},1000)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			editmb(){
				this.$api.editemail({...this.mbinfo}).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.$api.findListemail().then(res=>{
							console.log(res.data.list);
							this.mblist=res.data.list
						})
						setTimeout(()=>{
							this.addmbvisible = false;
						},1000)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			addmb(e){
				if(e.id){
					this.isadd=false
					this.$api.findbyIdListemail(e.id).then(res=>{
						console.log(res);
						this.mbinfo=res.data
					})
				}else{
					this.isadd=true
					this.mbinfo={}
				}
				this.addmbvisible=true
			},
			mb(){
				this.mbvisible=true
				this.$api.findListemail().then(res=>{
					console.log(res.data.list);
					this.mblist=res.data.list
				})
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.data !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			send(){
				this.$api.sendOneEmail({...this.emailInfo}).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.$api.findListemail().then(res=>{
							this.mblist=res.data.list
						})
						setTimeout(()=>{
							this.emailvisible = false;
						},1000)
					} else {
						this.$message.error(res.message);
					}
				})
				
			},
			beforeAvatarUpload1(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess1(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.data !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
			
			toyj(it){
				this.emailInfo={}
				this.emailInfo.email=it.email
				this.emailvisible=true
			},
			toShowProperty(userId) {
				this.userPropertyList = []
				this.propertyDialogVisible = true
				this.loadingUserProperty = true;
				this.$api.getUserProperty({
					pageNum: 1,
					pageSize: 20,
					userId: userId
				}).then((res) => { 
					res=JSON.parse(this.$decrypt(res.data))
					// console.log('资产列表---', res.data.data)
					if (res.state == 'success') {
						this.userPropertyList = res.data.data
					}
					this.loadingUserProperty = false;
				})

			},
		
			getOwnership(){ //网体归属
				// console.log(this.page);
				this.loadingTwo = true;
				let data={
					pageNum:this.page.WGPageNum,
					pageSize:this.page.WGPageSize,
					id: this.wgid
				}
				this.$api.ownership(data).then(res=>{
					this.twData = res.data
					this.loadingTwo = false;
				})
			},
			wangti(id){ //网体归属
				this.wgid = id
				this.wtDialogVisible=true
				this.getOwnership()
				
			},
			pageWgChange(data) { //网体归属
				// console.log(data);
				this.page.WGPageNum = data
				this.getOwnership()
			},
			handleWgSizeChange(val) { //网体归属
				this.page.WGPageSize = val
				this.getOwnership()
			},

			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				// this.goodsImages.remove(file.url);
				this.fileList = this.fileList.filter(item => item.uid !== file.uid)
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			onSuccess1(response, file) {
				console.log(response)
				this.goodsImages.push(response.message)
				this.fileList.push({
					"url": response.message
				})
				console.log("asda", this.fileList)
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getUserList()
			},
			findSysUserById(id) {
				this.$api.findSysUserById(id).then((res) => {
					if (res.state == 'success') {
						this.form.username = res.data.username
					}
				})
			},
			cannelPass() {
				this.editDialogVisible = false
			},
			//选择代理级别查询对用省市区数据
			chooseLevel(e) {
				if (e == 3 && this.cityId) {
					this.cityFcus(this.cityId)
				}
			},
			
			provinceFocus(e) { //查询市
				this.setTLevelData.areaId = null;
				this.provinceId = e;
				this.cityId = '';
				this.areaId = '';
				this.cityList = {}
				this.districtList = {}
			
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
			
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
							console.log('查询市--', res.data)
						}
					})
				}
			},
			
			cityFcus(e) { //查询区
				this.setTLevelData.areaId = null;
				this.cityId = e;
				this.areaId = '';
				this.districtList = {}
			
				/* let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				}); */
			
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
							console.log('查询区--', res.data)
						}
					})
				}
			
			},
			districtFcus(e) {
				this.areaId = e;
				/*let obj = {};
				 obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				}); */
			},
			showEditAgentDialogVisible(user) { //设置代理弹窗
				this.editAgentDialogVisible = true
				this.userForm = {}
				this.setTLevelData.userId = user.id
				this.proxyId = user.proxyId
				this.userId = user.id
				this.agentLevel = user.agentLevel
				console.log('设置代理点击的那条数据--', user);
				if(this.proxyId){
					this.setTLevelData = {}
					this.provinceId = ''
					this.cityId = ''
					this.areaId = ''
					
					this.$api.findUserAreaInfo(this.proxyId).then((res) => {
						if (res.state == 'success') {
							this.setTLevelData = res.data
							this.provinceId = res.data.provinceId
							this.cityId = res.data.cityId
							this.areaId = res.data.areaId
					
							if (res.data.agentLevel && res.data.agentLevel == 3) {
								//市
								this.$api.getAreasFive(res.data.provinceId).then((res) => {
									if (res.state == 'success') {
										this.cityList = res.data
									}
								})
					
								//区
								this.$api.getAreasFive(res.data.cityId).then((res) => {
									if (res.state == 'success') {
										this.districtList = res.data
									}
								})
								console.log(this.districtList)
							} else if (res.data.agentLevel && res.data.agentLevel == 2) {
								//市
								this.$api.getAreasFive(res.data.provinceId).then((res) => {
									if (res.state == 'success') {
										this.cityList = res.data
									}
								})
							}
					
						}
					})
				}else{
				
					this.setTLevelData = {}
					this.provinceId = ''
					this.cityId = ''
					this.areaId = ''
				}
				
			
			},
			editAgent() { // 代理设置确定按钮
				this.editAgentLoading = true;
				if (this.flag == 1) {
					let upAgency = {
						userId: this.userId,
						agentLevel: this.agentLevel,
						areaId: " ",
						id:this.proxyId ? this.proxyId : '',
					}
					
					if (upAgency.agentLevel == 1) {
						if (isNaN(this.setTLevelData.provinceName)) {
							upAgency.areaId = this.setTLevelData.provinceId
						} else {
							upAgency.areaId = this.setTLevelData.provinceName
						}
			
					} else if (upAgency.agentLevel == 2) {
						if (isNaN(this.setTLevelData.cityName)) {
							upAgency.areaId = this.setTLevelData.cityId
						} else {
							upAgency.areaId = this.setTLevelData.cityName
						}
					} else if (upAgency.agentLevel == 3) {
						if (isNaN(this.setTLevelData.areaName)) {
							upAgency.areaId = this.setTLevelData.areaId
						} else {
							upAgency.areaId = this.setTLevelData.areaName
						}
					}
					// console.log(upAgency, this.setTLevelData.data)
					this.$api.editSetLevel(upAgency).then((res) => {
						if (res.state == "success") {
							this.$message({
								message: res.message,
								type: "success",
							});
							this.getUserList();
							this.editAgentDialogVisible = false;
						} else if (res.status == 400) {
							this.$message.error("请重新选择");
						} else {
							this.$message.error(res.message);
						}
						this.editAgentLoading = false;
						
					});
			
				} else {
					const agency = {
						userId: this.userId,
						// username: this.userForm.username,
						agentLevel: this.setTLevelData.agentLevel,
						areaId: " ",
						id:this.proxyId ? this.proxyId : '',
						// status: this.setTLevelData.status
					}
					if (agency.agentLevel == 1) {
						agency.areaId = this.provinceId
					} else if (agency.agentLevel == 2) {
						agency.areaId = this.cityId
					} else if (agency.agentLevel == 3) {
						agency.areaId = this.areaId
					}
					this.$api.editSetLevel(agency).then((res) => {
						if (res.state == "success") {
							this.$message({
								message: res.message,
								type: "success",
							});
							this.getUserList();
							this.editAgentDialogVisible = false;
						} else {
							this.$message.error(res.message);
						}
						this.editAgentLoading = false;
						
					});
				}
			},

			// 编辑用户信息弹窗
			showEditUserDialogVisible(id) {
				this.userForm = {}
				this.ids = id
				this.editUserDialogVisible = true
				this.$api.getUserInfoByIdTwo(id).then((res) => {
					if (res.state == 'success') {
						this.userForm = res.data
						this.logo = res.data.logo
					}
				})
			},
			editUser() {
				this.userForm.id = this.ids
				this.userForm.logo = this.logo
				let data = {
					id: this.ids,
					username: this.userForm.username,
					nickname: this.userForm.nickname,
					phone:this.userForm.phone,
					isEnable: this.userForm.isEnable,
					isConsume: this.userForm.isConsume,
					isSubscribe: this.userForm.isSubscribe,
					logo: this.userForm.logo,
				};
				this.editUserLoading = true;
				this.$api.resetPass(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getUserList()
						this.editUserDialogVisible = false;
					} else {
						this.$message.error(res.message);
					}
					this.editUserLoading = false;
				})
			},
			//上传logo
			upLoadLogo(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					console.log('列表:', res);
					this.logo = res.message
				})
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				};
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			//重置密码弹框
			editialogVisible(id) {
				this.form.password = ""
				this.form.surePass = ""
				this.ids = id
				this.editDialogVisible = false;
				this.editDialogVisible = true;
			},
			//重置密码
			resetPass() {
				this.resetPassLoading = true;
				if (this.form.password !== this.form.surePass) {
					this.$message.error("两次密码不一致");
					return false;
				}
				var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
				var re = new RegExp(reg)
				if (!re.test(this.form.password)) {
					this.$message.error("请输入有效的登录密码");
					return false;
				}

				let data = {
					id: this.ids,
					password: this.form.password
				}
				this.$api.resetPass(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getUserList()
					} else {
						this.$message.error(res.message);
					}
					this.editDialogVisible = false;
					this.resetPassLoading = false;
				})
			},
			// 充值弹窗
			dialogVisibleFun(item) {
				this.integralId = ""
				this.ids = item.id
				this.payUserName = item.id +'-'+item.username
				this.appropriation = ''
				this.sureLoading = false
				this.rechargeType = 1;
				this.$api.getIntegralListTwo().then((res) => { //资产类型列表
					if (res.state == 'success') {
						this.integralList = res.data
						this.dialogVisible = true;
					}
				})
				
			},
			validateInput() {
				if (this.appropriation < 0) {
					// 输入的是负数，清空输入框的值
					this.appropriation = '';
				}
			},
			//提交充值
			sure() {
				this.sureLoading = true
				this.fileList.map(item => {
					console.log(item.url)
					this.cidImages.push(item.url)
				})
				let data = {
					userId: this.ids,
					integralId: this.integralId,
					amount: this.appropriation,
					rechargeMemo:this.remark,
					certificateImg:this.cidImages.join(','),
					type:this.rechargeType,
				}
				this.$api.getIntegralGly(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getUserList()
						this.dialogVisible = false;
					} else {
						this.$message.error(res.message);
					}
					this.sureLoading = false
				})
			},
			//删除
			toDelete(id) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.deleteSysUser(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getUserList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.getUserList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getUserList()
			},
			getUserList() {
				this.tableLoading = true
				let data = {
					email:this.searchInfo.email,
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					invitationCode: this.searchInfo.invitationCode,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
					username: this.searchInfo.username,
					id: this.searchInfo.id,
					phone: this.searchInfo.phone,
					isEnable: this.searchInfo.isEnable,
					isSubscribe: this.searchInfo.isSubscribe,
					orderType: this.searchInfo.orderType
				}
				this.$api.getMemberList(data).then((res) => { //会员列表
					if (res.state == 'success') {
						// console.log('表格数据--',res.data.list[0])
						this.userList = res.data
						this.tableLoading = false
					}else{
						this.$message({
							type: 'error',
							message: res.message
						});
					}
				})
			},
			toShowInvite(userId) {
				this.inviteData = []
				this.ids = userId
				this.inviteDialogVisible = true
				this.inviteDataLoading = false
				this.showInvite(userId);
			},
			pageInviteChange(data) {
				this.page.invitePageNum = data
				this.inviteDataLoading = false
				this.showInvite(this.ids)
			},
			handleInviteSizeChange(val) {
				this.page.invitePageSize = val
				this.inviteDataLoading = false
				this.showInvite(this.ids)
			},
			
			dialogTableLoad(tree, treeNode, resolve) {
				// console.log('参数---', tree)
				setTimeout(() => {
					const params = {
					//例如：需要传入的参数
						id: tree.id,
						pageNum: 1,
						pageSize: 20,
						// openId: tree.openId
					}
					this.$api.showInviteTwo(params).then(res=>{
						// console.log('res.data.list---',res.data.list)
						// resolve(this.inviteData = res.data.list)
						resolve( res.data.list)
					})
				}, 1000)
			},
			showInvite(userId) {
				this.inviteDataLoading = true;
				let data = {
					id: this.ids,
					pageNum: this.page.invitePageNum,
					pageSize: this.page.invitePageSize,
				}
				this.$api.showInviteTwo(data).then((res) => { 
					if (res.state == 'success') {
						// console.log('邀请下级---', res.data.list[0])
						this.inviteData = res.data
					}else{
						this.$message({
							type: 'error',
							message: res.message
						});
					}
					this.inviteDataLoading = false
				})
			},
		},
		created() {
			this.getUserList();
			
			this.$api.getAreasFive(0).then((res) => { //查询省
				if (res.state == 'success') {
					this.provinceList = res.data
					// console.log('查询省--', res.data)
				}
			})
		}
	};
</script>

<style scoped>
	.demo-table-expand {
		font-size: 0;
		margin-left: 70px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>